import { AfterViewInit, Component, Injector } from '@angular/core';
import { BaseAdminPanelComponent } from "../admin-panel/base-admin-panel/base-admin-panel.component";
import { DiagnosticsService, ObjectDiagnosticsModel } from "../../services/diagnostics.service";
import { ObjectsManagementDialogComponent } from "../admin-panel/objects-management-dialog/objects-management-dialog.component";
import { ApplicationUserStatisticsView, UserViewModel } from "../../services/users.service";
import { EditObjectsComponent } from "../admin-panel/Objects/edit-objects.component";
import { ObjectsService } from "../../services/objects.service";
import { SetPayedTillDialogComponent } from "./set-payed-till-dialog/set-payed-till-dialog.component"
import { FilterData } from "../shared/components/objects-filter/objects-filter.component"
import { IManagableObject } from '../admin-panel/IManagableObject';
import { ObjectFilterType } from '../shared/pipes/FilterObjects.pipe';

@Component({
    selector: 'app-diagnostics',
    templateUrl: './diagnostics.component.html',
    styleUrls: ['./diagnostics.component.css'],
    standalone: false
})
export class DiagnosticsComponent extends BaseAdminPanelComponent implements AfterViewInit {

  private diagnosticsService: DiagnosticsService;

  loadedObjects: ObjectDiagnosticsModel[] = [];
  selectedUsersDesc = "All";
  UniqueOnly = true;
  ShowStatus = false;

  public filterType: ObjectFilterType = ObjectFilterType.Name;

  public users: ApplicationUserStatisticsView[] = [];

  private objectsService: ObjectsService

  oldTimestampCount = 0;
  blockedCount = 0;
  now = (new Date()).getTime();
  day = 3600000 * 24;

  constructor(protected injector: Injector) {
    super(injector);
    this.diagnosticsService = injector.get(DiagnosticsService);
    this.objectsService = injector.get(ObjectsService);
  }

  ngAfterViewInit() {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "Diagnostics" }));
    this.usersService.getUsers().subscribe(users => {
      console.log(users);
      this.users = users;
      for (let i = 0; i < this.users.length; i++)
        this.users[i].IsChecked = (this.users[i].Id == this.usersService.getCurrentUser().Id);

      this.afterUsersSelect();
      //this.refresh();
    });
  }

  public refresh() {
    let users = [];
    for (let i = 0; i < this.users.length; i++)
      if (this.users[i].IsChecked)
        users.push(this.users[i].Id);

    this.loadedObjects = [];
    this.diagnosticsService.GetReport(users).subscribe(arr => { this.loadedObjects = arr; this.applyFilter(); });
  }

  public getObjects(): ObjectDiagnosticsModel[] {
    return this.objects as ObjectDiagnosticsModel[];
  }

  getStatus(status: number): string {
    switch (status) {
      case 0:
        return 'Blocked';
      case 1:
        return 'Active';
      case 10:
        return 'Broken';
      case 11:
        return 'In service';
      case 15:
        return 'Not installed';
    }
    return '';
  }

  public onExtendedTermChange(data: FilterData) {
    this.filterType = data.searchType;
    this.nameFilter = data.searchFilter;
    this.applyFilter();
  }

  protected applyFilter(): void {
    let map = {};
    for (let i = 0; i < this.users.length; i++)
      if (this.users[i].IsChecked)
        map[this.users[i].Id] = 1;

    this.oldTimestampCount = 0;
    this.blockedCount = 0;

    this.objects = [];
    for (let i = 0; i < this.loadedObjects.length; i++) {
      if (this.nameFilter != "") {
        if (this.filterType == ObjectFilterType.Name && this.loadedObjects[i].Name.toLowerCase().indexOf(this.nameFilter.toLowerCase()) < 0)
          continue;
        if (this.filterType == ObjectFilterType.IMEI && this.loadedObjects[i].IMEI.toLowerCase().indexOf(this.nameFilter.toLowerCase()) < 0)
          continue;
        if (this.filterType == ObjectFilterType.Phone && this.loadedObjects[i].Phone.toLowerCase().indexOf(this.nameFilter.toLowerCase()) < 0)
          continue;
        if (this.filterType == ObjectFilterType.Equipment && this.loadedObjects[i].DeviceModel.toLowerCase().indexOf(this.nameFilter.toLowerCase()) < 0)
          continue;
      }

      if (this.UniqueOnly && !this.loadedObjects[i].Owned)
        continue;

      if (!map[this.loadedObjects[i].UserId])
        continue;

      if (this.loadedObjects[i].Status == 0)
        this.blockedCount++;

      if (this.loadedObjects[i].Time < this.now - this.day * 7)
        this.oldTimestampCount++;

      this.objects.push(this.loadedObjects[i]);
    }
  }


  afterUsersSelect() {
    let count = 0;
    this.selectedUsersDesc = "";
    for (let i = 0; i < this.users.length; i++)
      if (this.users[i].IsChecked) {
        this.selectedUsersDesc += this.users[i].Name + " ";
        count++;
      }

    if (count == 0)
      this.selectedUsersDesc = "Select a user";

    if (count > 2)
      this.selectedUsersDesc = count + " users";

    if (count == this.users.length)
      this.selectedUsersDesc = "All";

    this.refresh();
    //this.applyFilter();
  }

  public selectUsers() {
    this.prepareModal(ObjectsManagementDialogComponent);

    this.componentRef.instance.objects = this.users;
    this.componentRef.instance.isSingleItem = false;

    this.componentRef.instance.onSubmit.subscribe(() => {
      this.afterUsersSelect();
      this.componentRef.instance.close();
    });
    this.componentRef.instance.open();
  }
  public setUnique(unique: boolean) {
    this.UniqueOnly = unique;
    this.applyFilter();
  }
  public setShowStatus(unique: boolean) {
    this.ShowStatus = unique;
  }

  public openEditModal(obj: ObjectDiagnosticsModel) {
    this.prepareModal(EditObjectsComponent);
    this.componentRef.instance.WorkAsOwner = true;
    this.componentRef.instance.show(obj.Id);
  }
  public deleteDevice(obj: ObjectDiagnosticsModel) {
    if (!confirm(this.translate.instant("Delete") + " " + obj.Name + "?")) return;

    return this.objectsService.DeleteObjectAsOwner(obj.Id).subscribe(() => {
      //this.refresh();
      for (let i = 0; i < this.loadedObjects.length; i++)
        if (this.loadedObjects[i].Id == obj.Id)
          this.loadedObjects.splice(i, 1);
      this.applyFilter();
    });
  }
  public onSetPayed() {
    const objects = [];
    for (let i = 0; i < this.objects.length; i++)
      if (this.objects[i].IsChecked)
        objects.push(this.objects[i].Id);

    if (objects.length > 0) {
      let now = new Date();
      now = new Date(now.setFullYear(now.getFullYear() + 1));

      this.prepareModal(SetPayedTillDialogComponent);
      this.componentRef.instance.PayedTill = now.getTime();
      this.componentRef.instance.open();
      this.componentRef.instance.onSubmit.subscribe(() => {
        this.objectsService.SetPayedTill(objects, this.componentRef.instance.PayedTill).subscribe(() => { this.refresh(); });
      });
    }
  }
}
